import logo from '../../images/logo.svg';
import * as React from 'react';

export const PrivacyPolicy = () => {
return (
<div className="basic-container" style={{maxWidth:'800px'}}>
<img src={logo} className="logo" style={{marginBottom:'40px'}}/>
<h1> Политика конфиденциальности  </h1>
<br />
<p>
Политика конфиденциальности персональных данных Пользователей (далее — Политика конфиденциальности) платформы РТСИМ.Карьера (в том числе программный продукт РТСИМ.Карьера, сайт rtsim.ru и другие объекты, относящиеся к ООО «РТСИМ») (далее – Платформа). действует в отношении информации, которая предоставляется физическими лицами, использующими или имеющими намерение использовать Платформу ООО «РТСИМ» (далее – Пользователи) добровольно в целях использования платформы РТСИМ.Карьера в соответствии с Федеральным законом «О персональных данных» от 27.07.2006 No 152-ФЗ.
</p>
<br />
<p>
К ней относятся, в частности, сведения об имени, фамилии и отчестве Пользователей, должности, месте работы, учебы, номера телефона, адреса электронной почты, информации о совершаемых действиях на Платформе и иная статистика Платформы, а также иная информация, составляющая коммерческую, личную или какую-либо другую охраняемую законом тайну.
</p>
<br />
<p>
Пользователь признает, что сведения о Пользователях, находящиеся либо находившиеся в свободном доступе, не составляют предмет какой-либо тайны.
</p>
<br />
<p>
Регистрируясь на Платформе, Пользователь подтверждает, что с надлежащей добросовестностью ознакомился с условиями Политики конфиденциальности ООО «РТСИМ» и принимает их без каких-либо дополнительных замечаний.
</p>
<br />
<p>
Пользователь всегда может отказаться от получения информационных сообщений, направив Оператору письмо на адрес электронной почты info@rtsim.ru с пометкой «Отказ от уведомлений о новых продуктах и услугах и специальных предложениях».
</p>
<br />
<p>
Обезличенные данные Пользователей, собираемые с помощью сервисов интернет-статистики, служат для сбора, записи, систематизации, накопления, хранения, уточнения (обновления, изменения), извлечения, использования, обезличивания, блокирования, удаления, уничтожения, передача (предоставление, доступ), в том числе трансграничная, партнёрам ООО «РТСИМ», предоставляющим сервис по указанным метрическим программам информации о действиях Пользователей на Платформе, улучшения качества и содержания Платформы, совершенствования продуктов и услуг ООО «РТСИМ», определения предпочтений Пользователя, предоставления целевой информации по продуктам и услугам ООО «РТСИМ» и его партнёров.
</p>
<br />
<p>
Мы используем защищённые серверные системы для шифрования персональных данных.
</p>
<br />
<p>
1. Общие положения
</p>
<br />
<p>
1.1. ООО «РТСИМ» не контролирует и не несет ответственность за электронные ссылки, содержащие информацию об услугах и товарах третьих лиц, которые могут быть доступны на Платформе.
</p>
<br />
<p>
1.2. Администрация Платформы не проверяет достоверность персональных данных, предоставляемых Пользователем, однако Пользователь обязуется предоставлять информацию в соответствии с требованиями п.3.4. настоящей Политики конфиденциальности.
</p>
<br />
<p>
1.3. ООО «РТСИМ» не несет ответственности в случае, если недостоверная информация, размещенная Пользователем на Платформе, повлечет прямые и(или) косвенные убытки третьих лиц либо самого Пользователя.
</p>
<br />
<p>
2. Предмет политики конфиденциальности
</p>
<br />
<p>
2.1. Настоящая Политика конфиденциальности устанавливает обязательства Администрации Платформы по обеспечению режима защиты конфиденциальности персональных данных, которые Пользователь предоставляет по запросу Администрации Платформы при регистрации и использовании Платформы.
</p>
<br />
<p>
2.2. Персональные данные, разрешённые к обработке в рамках настоящей Политики конфиденциальности, предоставляются Пользователем путём заполнения формы в Платформе.
</p>
<br />
<p>
2.3. Любая персональная информация, неоговоренная выше, подлежит хранению за исключением случаев, предусмотренных в п.п. 3.3. и 5.2. настоящей Политики конфиденциальности.
</p>
<br />
<p>
2.4. Персональные данные Пользователя могут быть использованы в целях:
</p>
<br />
<p>
2.4.1. Идентификации Пользователя.
</p>
<br />
<p>
2.4.2. Предоставления Пользователю доступа к персонализированным ресурсам.
</p>
<br />
<p>
2.4.3. Установления с Пользователем обратной связи, включая направление уведомлений, запросов и заявок от Пользователя.
</p>
<br />
<p>
2.4.4. Подтверждения достоверности и полноты персональных данных, предоставленных Пользователем.
</p>
<br />
<p>
2.4.5. Создания учетной записи.
</p>
<br />
<p>
2.4.6. Уведомления Пользователя о состоянии Запроса.
</p>
<br />
<p>
2.4.7. Предоставления Пользователю эффективной клиентской и технической поддержки.
</p>
<br />
<p>
2.4.8. Предоставления Пользователю с его согласия обновлений продукции, специальных предложений, информации о ценах, новостной рассылки и иных сведений.
</p>
<br />
<p>
2.4.9. Осуществления рекламной деятельности.
</p>
<br />
<p>
2.4.10. Осуществления иных действий, связанных с оказанием услуг Пользователю.
</p>
<br />
<p>
2.4.11. Настоящее согласие предоставляется Пользователем на осуществление действий в отношении персональных данных Пользователя, которые необходимы для достижения указанных выше целей, включая (без ограничения) сбор, систематизацию, накопление, хранение, уточнение (обновление, изменение), использование, передачу третьим лицам для осуществления указанных выше целей, обезличивание, блокирование персональных данных, а также осуществление любых иных действий, предусмотренных действующим законодательством Российской Федерации.
</p>
<br />
<p>
3. Порядок хранения персональной информации
</p>
<br />
<p>
3.1. Обработка персональных данных Пользователя осуществляется без ограничения срока любым законным способом, в том числе в информационных системах персональных данных с использованием средств автоматизации или без использования таких средств.
</p>
<br />
<p>
3.2. Пользователь соглашается с тем, что обработка персональных данных осуществляется для реализации прав и законных интересов ООО «РТСИМ» или третьих лиц, либо для достижения общественно значимых целей при условии, что при этом не нарушаются права и свободы Пользователя.
Обработка персональных данных осуществляется в целях продвижения товаров, работ, услуг на рынке путем осуществления прямых контактов с потенциальным потребителем с помощью средств связи, а также в целях политической агитации.
</p>
<br />
<p>
3.3. Персональные данные Пользователя могут быть переданы уполномоченным органам государственной власти Российской Федерации только по основаниям и в порядке, установленным законодательством Российской Федерации.
</p>
<br />
<p>
3.4. Для регистрации Пользователь обязуется предоставить достоверную и полную информацию о себе по вопросам, предлагаемым в бланке регистрации, и добросовестно поддерживать эту информацию в актуальном состоянии, своевременно внося соответствующие корректировки. Если Пользователь предоставляет неверную информацию или у ООО «РТСИМ» есть основания полагать,
что предоставленная Пользователем информация не соответствует действительности, ООО «РТСИМ» имеет право по своему усмотрению заблокировать либо удалить учетную запись Пользователя и отказать Пользователю в использовании своих сервисов, либо их отдельных функций.
</p>
<br />
<p>
3.5. Пользователь обязуется ограничить доступ третьих лиц к своему Личному Кабинету, а также добросовестно следить за соблюдением режима конфиденциальности в отношении информации об индивидуальном пароле его Личного Кабинета. Пользователь подтверждает, что ООО «РТСИМ» не несет ответственности за прямые или косвенные убытки, которые были причинены в результате доступа третьих лиц к Личному Кабинету Пользователя. Поддержание безопасности Личного Кабинета являются обязанностями Пользователя.
</p>
<br />
<p>
3.6. Пользователь несет ответственность перед третьими лицами за свои действия, связанные с использованием Платформы, в том числе если такие действия приведут к нарушению прав и законных интересов третьих лиц. Предъявление регрессных требований к ООО «РТСИМ» в связи с нарушением Пользователем при эксплуатации Платформы прав и законных интересов третьих лиц не допускается.
</p>
<br />
<p>
4. Ответственность и порядок разрешения споров
</p>
<br />
<p>
4.1. Стороны несут ответственность в соответствии с действующим законодательством Российской Федерации.
</p>
<br />
<p>
4.2. В случае утраты или разглашения Конфиденциальной информации ООО «РТСИМ» не несёт ответственность, если данная конфиденциальная информация:
</p>
<br />
<p>
4.2.1. Стала публичным достоянием до её утраты или разглашения. 
</p>
<br />
<p>
4.2.2. Была получена от третьей стороны до момента её получения ООО «РТСИМ». 4.2.3. Была разглашена с согласия Пользователя. 
</p>
<br />
<p>
4.2.4. Стала общедоступной в результате неправомерных действий третьих лиц. 
</p>
<br />
<p>
5. Разрешение споров
</p>
<br />
<p>
5.1. Пользователь соглашается с тем, что претензионный порядок разрешения споров и разногласий является обязательным. Срок рассмотрения и направления ответа на письменную претензию составляет 5 (пять) рабочих дней.
</p>
<br />
<p>
5.2. При недостижении соглашения спор будет передан на рассмотрение в суд в соответствии с порядком, предусмотренным действующим законодательством Российской Федерации.
</p>
<br />
<p>
6. Дополнительные условия
</p>
<br />
<p>
6.1. ООО «РТСИМ» вправе вносить изменения в настоящую Политику конфиденциальности без согласия и уведомления Пользователя. Подобные изменения вступают в силу со дня их опубликования на сайте rtsim.ru
</p>
<br />
<p>
6.2. Пользователь обязуется своевременно знакомиться с вносимыми изменениями и подтверждает свою ответственность за последствия несвоевременного ознакомления с ними.
</p>
<br />
<p>
6.3. Пользователь может получить любые разъяснения по интересующим вопросам, касающимся обработки его персональных данных, обратившись к Оператору с помощью электронной почты info@rtsim.ru.
</p>
</div>
)
}